export default "__VITE_ASSET__f3dfd2e4__"